import { fork, take } from 'redux-saga/effects'
import { appActions } from './actions'
import session from '../session';

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchInitApp() {
  while (true) {
    const { payload } = yield take(appActions.INIT_APP);

    if (payload.check_session){
      session.validateSession();
    }
  }
}

//=====================================
//  ROOT
//-------------------------------------

export const appSagas = [
  fork(watchInitApp)
]